/**
 * Hand-written wrapper for the Calculator v3 Margin Ladder endpoints.
 * Once the BE deploys to dev, `npm run api-generate` will produce a
 * typed client and this file can be collapsed to re-export from it.
 */
import axiosInstance from './axios';

export type MarginTierLabel =
  | 'below_floor'
  | 'floor'
  | 'acceptable'
  | 'win';

export interface MarginLadderTierResolved {
  acceptableMargin: number;
  contractSizeMax: number | null;
  contractSizeMin: number;
  floorMargin: number;
  id: string;
  isGlobalDefault: boolean;
  winMargin: number;
}

export interface MarginCheckResult {
  currentMargin: number;
  message: string;
  monthlyValue: number;
  requiresApproval: boolean;
  tier: MarginTierLabel;
  tierRow: MarginLadderTierResolved;
}

const list = async (): Promise<MarginLadderTierResolved[]> => {
  const { data } = await axiosInstance.get<MarginLadderTierResolved[]>(
    '/margin-ladder',
  );
  return data;
};

const check = async (
  monthlyValue: number,
  currentMargin: number,
): Promise<MarginCheckResult> => {
  const { data } = await axiosInstance.post<MarginCheckResult>(
    '/margin-ladder/check',
    { currentMargin, monthlyValue },
  );
  return data;
};

export interface TenantMarginTierDto {
  acceptableMargin: number;
  contractSizeMax?: number | null;
  contractSizeMin: number;
  floorMargin: number;
  winMargin: number;
}

const replaceLadder = async (
  tiers: TenantMarginTierDto[],
): Promise<MarginLadderTierResolved[]> => {
  const { data } = await axiosInstance.put<MarginLadderTierResolved[]>(
    '/margin-ladder',
    { tiers },
  );
  return data;
};

const marginLadderApi = { check, list, replaceLadder };

export default marginLadderApi;
